/**
 * Game Configuration Types
 * Автоматически генерируется balance-importer
 *
 * Этот файл автоматически генерируется на основе конфигурации balance-importer.
 * Не редактируйте вручную - изменения будут перезаписаны.
 *
 * Generated at: 2025-09-25T12:43:18.995Z
 */

export enum ConfigType {
  GAME_CONSTANTS = 'GAME_CONSTANTS',
  ITEMS = 'ITEMS',
  CRAFTS = 'CRAFTS',
  UPGRADES = 'UPGRADES',
  GALAXIES = 'GALAXIES',
  SECTORS = 'SECTORS',
  ASTEROIDS = 'ASTEROIDS',
  ASTEROID_SIZES = 'ASTEROID_SIZES',
  ASTEROID_MIXES = 'ASTEROID_MIXES',
  ASTEROID_MIX_ENTRIES = 'ASTEROID_MIX_ENTRIES',
  LOOT_POOLS = 'LOOT_POOLS',
  LOOT_POOL_ENTRIES = 'LOOT_POOL_ENTRIES',
}
